<div class="privacy-policy-container">
    <div class="last-updated"><em>Last Updated:</em> April 2026</div>
    <ol class="privacy-policy-lists">
        <li class="privacy-list">
            <h3 class="list-header-text">Introduction</h3>
            <p class="list-content">Welcome to Capvizon. We respect your privacy
                and are committed to
                protecting your personal data. This policy outlines how we
                handle
                information for users in the USA, UK, Canada, India, and
                Australia.</p>
        </li>

        <li class="privacy-list">
            <h3 class="list-header-text">Data We Collect</h3>
            <p class="list-content">We collect personal information necessary to
                provide our expense
                tracking services:</p>
            <p class="list-content"><strong class="sub-header-text">Identity
                    Data:</strong> Name, Physical Address.</p>
            <p class="list-content"><strong class="sub-header-text">Contact
                    Data:</strong> Email Address, Phone Number.</p>
            <p class="list-content"><strong class="sub-header-text">Financial
                    Input:</strong> Manual entries of expenses, group
                balances, and categories.</p>
            <p class="list-content"><strong
                    class="sub-header-text">Note:</strong> We do not process or
                store bank account or credit card
                numbers.</p>
        </li>

        <li class="privacy-list">
            <h3 class="list-header-text">Age Eligibility</h3>
            <p class="list-content">Our services are not intended for children
                under the age of 13. By
                using this site, you confirm that you are at least 13 years old.
                We
                do not knowingly collect data from children under this age.</p>
        </li>

        <li class="privacy-list">
            <h3 class="list-header-text">Data Storage & International
                Transfers</h3>
            <p class="list-content">Your data is stored on secure servers in
                India and the United
                States. By using our services, you acknowledge that your
                information may be
                transferred to and processed in these countries, which may have
                different data protection laws than your country of
                residence.</p>
        </li>

        <li class="privacy-list">
            <h3 class="list-header-text">Data Retention & Deletion</h3>
            <p class="list-content">We retain your information only as long as
                your account is active.
                You may delete your account and all associated data at any time
                through
                your Profile Page.</p>
        </li>

        <li class="privacy-list">
            <h3 class="list-header-text">Copyright and Infringement
                (DMCA/IP)</h3>
            <p class="list-content">If you believe that any content on Capvizon
                infringes upon your intellectual property rights, please notify
                us at <ccdl-link
                    linkText="Privacy and Terms
                    Team."
                    linkType="default"
                    size="xs"
                    [underlineOnHover]="true"
                    [ishrefLink]="true"
                    linkType="link"
                    [routeLink]="'mailto:privacyandterms@capvizon.com'">
                </ccdl-link>
            </p>
            <p class="list-content">
                <strong class="sub-header-text">Response Period:</strong>
                We will review and respond to valid infringement claims. Formal
                legal review regarding such claims shall only be initiated if no
                resolution or response is provided by us within
                <strong class="content-strong-text">90 days</strong> of your
                initial email notice.</p>
        </li>

        <li class="privacy-list">
            <h3 class="list-header-text">Contact Information</h3>
            <p class="list-content">For any privacy inquiries or to exercise
                your data rights (such as
                access or rectification), please contact:
                <ccdl-link
                    linkText="Privacy and Terms
                    Team."
                    linkType="default"
                    size="xs"
                    [underlineOnHover]="true"
                    [ishrefLink]="true"
                    linkType="link"
                    [routeLink]="'mailto:privacyandterms@capvizon.com'">
                </ccdl-link>
            </p>
        </li>
        <li class="privacy-list">
            <p class="list-content">For complete details: <ccdl-link
                    linkText="Read our full Privacy Policy."
                    linkType="default"
                    size="xs"
                    [underlineOnHover]="true"
                    linkType="link"
                    linkTarget="_blank"
                    [routeLink]="'legal/privacy-policy'">
                </ccdl-link></p>
        </li>
    </ol>
</div>